// src/components/layout/Header.jsx
import React from 'react';
import { Menu, User } from 'lucide-react';
import GramopollImage from '../assets/logo-text.png';

const Header = ({ menuOpen, setMenuOpen }) => {
  document.addEventListener('click', (event) => {
    const menuButton = document.querySelector('.open-menu-button');
    const sideMenu = document.querySelector('.side-menu');
    if (menuButton && !menuButton.contains(event.target)) {
      if(sideMenu && sideMenu.contains(event.target)) return;
      setMenuOpen(false);
    }
  });
  
  return (
  <div className="bg-gradient-to-r from-[#068cb0] to-[#033f4f] p-4 rounded-b-xl shadow-md flex justify-between items-center">
    <div className="flex items-center">
      <Menu 
        className="text-white mr-3 cursor-pointer open-menu-button" 
        onClick={() => setMenuOpen(!menuOpen)}
      />
      <h1 className="text-white text-xl font-semibold p-3 px-5 bg-opacity-70 bg-white rounded-xl">
        <img src={GramopollImage} alt="GramopoolImage" className="h-12" />
      </h1>
    </div>
    <div className="flex items-center justfy-between gap-2">
      <p className='text-white font-bold text-lg'>
        {sessionStorage.getItem('userName') ?? "Login"}
      </p>
      <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm">
        <User
          size={20}
          className="text-green-600"
        />
      </div>
    </div>
  </div>
)};

export default Header;